// src/pages/AlbumPage.jsx
import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { firebaseService } from "../services/firebaseService";
import { DEPORTES } from "../data/deportes";
import Lightbox from "../components/Lightbox";
import Foto from "../components/Foto";
import "../styles/albumPage.css";

const fecha = (iso) =>
    iso ? new Date(iso).toLocaleDateString("es-MX", { month: "long", year: "numeric" }) : "";

export default function AlbumPage() {
    const { albumId } = useParams();
    const [album, setAlbum] = useState(null);
    const [loading, setLoading] = useState(true);
    const [open, setOpen] = useState(-1);

    useEffect(() => {
        setLoading(true);
        firebaseService.getAlbum(albumId)
            .then(setAlbum)
            .catch((e) => console.error("Error cargando álbum:", e))
            .finally(() => setLoading(false));
    }, [albumId]);

    useEffect(() => {
        if (album) document.title = `${album.nombre} · Lorely`;
        return () => { document.title = "Lorely · Fotografía deportiva en CDMX"; };
    }, [album]);

    if (loading) {
        return <div className="state page-top"><div className="spinner" /></div>;
    }

    const deporte = album && DEPORTES[album.deporte];
    if (!album || !deporte) {
        return (
            <div className="state page-top">
                <h1 className="display">Álbum no encontrado</h1>
                <Link to="/" className="btn">Volver al inicio</Link>
            </div>
        );
    }

    const fotos = album.fotos;

    return (
        <div className="album-page page-top">
            <header className="album-head">
                <Link to={`/deporte/${deporte.id}`} className="mono back-link">← {deporte.nombre}</Link>
                <h1 className="display">{album.nombre}</h1>
                <div className="album-head-meta">
                    {album.descripcion && <p>{album.descripcion}</p>}
                    <span className="mono">
                        {fotos.length} fotos{album.fechaCreacion && ` · ${fecha(album.fechaCreacion)}`}
                    </span>
                </div>
            </header>

            {fotos.length > 0 ? (
                <div className="gallery">
                    {fotos.map((foto, i) => (
                        <button
                            key={foto.id}
                            className="gallery-item"
                            onClick={() => setOpen(i)}
                            aria-label={`Ver foto ${i + 1} de ${fotos.length}`}
                        >
                            <Foto url={foto.url} alt={`${album.nombre}, foto ${i + 1}`} eager={i < 3} />
                        </button>
                    ))}
                </div>
            ) : (
                <div className="state">Este álbum todavía no tiene fotos.</div>
            )}

            {open >= 0 && (
                <Lightbox photos={fotos} index={open} onChange={setOpen} onClose={() => setOpen(-1)} />
            )}
        </div>
    );
}
